import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { scoreTone } from "@/lib/constants";
import { Euro, ShieldCheck, CalendarClock, Building2, Sparkles, ArrowUpRight } from "lucide-react";

const ROWS = [
  { key: "compatibilita", label: "Compatibilità", render: (g) => `${g.compatibilita}%` },
  { key: "ente", label: "Ente" },
  { key: "tipologia", label: "Tipologia" },
  { key: "importo_max", label: "Importo max", icon: Euro },
  { key: "copertura", label: "Copertura", icon: ShieldCheck },
  { key: "ambito_territoriale", label: "Ambito" },
  { key: "scadenza", label: "Scadenza", icon: CalendarClock },
  { key: "analisi_ia", label: "Analisi IA" },
];

export function ComparisonModal({ grants, open, onOpenChange }) {
  if (!grants || grants.length === 0) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] max-w-5xl overflow-auto" data-testid="comparison-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-display text-2xl font-bold text-slate-900">
            <Sparkles className="h-5 w-5 text-indigo-500" />
            Confronto bandi ({grants.length})
          </DialogTitle>
          <DialogDescription>Confronta i bandi selezionati fianco a fianco per scegliere il più adatto.</DialogDescription>
        </DialogHeader>

        <div className="overflow-x-auto">
          <table className="w-full border-collapse text-sm">
            <thead>
              <tr>
                <th className="sticky left-0 z-10 bg-white p-2" />
                {grants.map((g) => {
                  const tone = scoreTone(g.compatibilita || 0);
                  return (
                    <th key={g.id} className="min-w-[220px] p-3 text-left align-top">
                      <div className={`rounded-xl border p-3 ${tone.cls}`}>
                        <div className="font-mono text-xl font-bold">{g.compatibilita}%</div>
                        <div className="mt-1 font-display text-sm font-bold leading-tight text-slate-900">{g.titolo}</div>
                      </div>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {ROWS.map((row) => (
                <tr key={row.key} className="border-t border-slate-100 align-top">
                  <td className="sticky left-0 z-10 bg-white p-3 text-xs font-bold uppercase tracking-wide text-slate-400">
                    <span className="flex items-center gap-1.5">
                      {row.icon && <row.icon className="h-3.5 w-3.5" />}{row.label}
                    </span>
                  </td>
                  {grants.map((g) => (
                    <td key={g.id} className="p-3 text-slate-700" data-testid="comparison-cell">
                      {row.render ? row.render(g) : (g[row.key] || "—")}
                    </td>
                  ))}
                </tr>
              ))}
              <tr className="border-t border-slate-100">
                <td className="sticky left-0 z-10 bg-white p-3 text-xs font-bold uppercase tracking-wide text-slate-400">
                  <span className="flex items-center gap-1.5"><Building2 className="h-3.5 w-3.5" />Portale</span>
                </td>
                {grants.map((g) => (
                  <td key={g.id} className="p-3">
                    {g.link_ufficiale ? (
                      <a href={g.link_ufficiale} target="_blank" rel="noopener noreferrer"
                        className="inline-flex items-center gap-1 text-indigo-600 hover:underline">
                        Apri <ArrowUpRight className="h-3.5 w-3.5" />
                      </a>
                    ) : "—"}
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      </DialogContent>
    </Dialog>
  );
}
